package com.macrofocus.eflux.components

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.animation.Easing
import com.macrofocus.eflux.animation.Playback
import com.macrofocus.eflux.animation.ZoomEasing
import com.macrofocus.eflux.animation.timeline
import com.macrofocus.eflux.diagram.DiagramType
import deckgl.util.calculateZoomLevel
import kotlinx.browser.window
import mui.material.Button
import mui.material.ButtonVariant
import mui.system.sx
import org.locationtech.jts.geom.Geometry
import react.FC
import react.Props
import web.cssom.None

external interface ZoomButtonProps : Props {
    var dataLoader: DataLoader
    var geometry: Geometry?
    var margin : Double?
}

val InstantZoomButton = FC<ZoomButtonProps> { props ->
    Button {
        sx {
            textTransform = None.none
        }

        variant = ButtonVariant.contained

        onClick = {
            val physicalGeometry = props.geometry
            if(physicalGeometry != null) {
                val envelope = physicalGeometry.envelopeInternal
                val zoom = calculateZoomLevel(
                    envelope.minX,
                    envelope.minY,
                    envelope.maxX,
                    envelope.maxY,
                    window.innerWidth,
                    window.innerHeight,
                    props.margin ?: 0.05
                )

                props.dataLoader.threeDZoom.value = zoom
                val centroid = physicalGeometry.centroid
                props.dataLoader.threeDLatitude.value = centroid.y
                props.dataLoader.threeDLongitude.value = centroid.x
            }
        }

        +"Zoom"
    }
}

val AnimatedZoomButton = FC<ZoomButtonProps> { props ->
    Button {
        sx {
            textTransform = None.none
        }

        variant = ButtonVariant.contained

        onClick = {
            val physicalGeometry = props.geometry
            if(physicalGeometry != null) {
                val envelope = physicalGeometry.envelopeInternal
                val zoom = calculateZoomLevel(
                    envelope.minX,
                    envelope.minY,
                    envelope.maxX,
                    envelope.maxY,
                    window.innerWidth,
                    window.innerHeight,
                    props.margin ?: 0.05
                )

                val timeline = timeline {
                    val duration: Long = 15000 / 2
                    parallel {
                        property(props.dataLoader.threeDZoom, 11.0, duration, ZoomEasing())
                        val centroid = physicalGeometry.centroid
                        property(props.dataLoader.threeDLatitude, centroid.y, duration, Easing.QUAD_OUT)
                        property(props.dataLoader.threeDLongitude, centroid.x, duration, Easing.QUAD_OUT)
                        //                                property(dataLoader.threeDPitch, 60.0, duration, Easing.QUAD_IN)
                    }
                    parallel {
                        property(props.dataLoader.threeDZoom, zoom, duration, ZoomEasing())
                    }
                }

                props.dataLoader.playback.value = Playback(timeline, DiagramType.ThreeD)
            }
        }

        +"Animated Zoom"
    }
}